import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { ITEMS_PATH } from "~restock/data-management/items/helpers/itemsRoutes";

export const RESTOCK_ITEM_TARGET_KIND = "restockItem";

export const NEW_RESTOCK_ITEM_TARGET_KIND = "newRestockItem";

export const RESTOCK_ITEMS_DOCK_PAGE_ID = "data-management-items";

const NEW_ITEM_ROUTE_SEGMENT = "new";

const RESTOCK_ITEM_ROUTE_PATTERN = /^\/restock\/data-management\/items\/([^/?#]+)$/;

const itemRouteSegment = (pathname: string): null | string => {
	const match = RESTOCK_ITEM_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return decodeURIComponent(match[1]);
	} catch {
		return null;
	}
};

export const matchRestockItemReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const segment = itemRouteSegment(pathname);
	return segment && segment !== NEW_ITEM_ROUTE_SEGMENT
		? { targetId: segment, targetKind: RESTOCK_ITEM_TARGET_KIND }
		: null;
};

export const NEW_RESTOCK_ITEM_TARGET: ContinuationTarget = {
	targetId: NEW_ITEM_ROUTE_SEGMENT,
	targetKind: NEW_RESTOCK_ITEM_TARGET_KIND
};

export const matchNewRestockItemReceiverRoute = (pathname: string): ContinuationTarget | null =>
	itemRouteSegment(pathname) === NEW_ITEM_ROUTE_SEGMENT ? NEW_RESTOCK_ITEM_TARGET : null;

export const newRestockItemReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => `${ITEMS_PATH}/${NEW_ITEM_ROUTE_SEGMENT}`,
	matchesRoute: matchNewRestockItemReceiverRoute
};

const restockItemReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${ITEMS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchRestockItemReceiverRoute
};

export default restockItemReceiverIdentityAdapter;
